import { useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { defaultOnError } from "util/conditional/onError";
import { qualifyUrl } from "util/URLUtils";
import { urlPrefix } from "./useArchiveConfig";
const url = qualifyUrl(`${urlPrefix}/config/snapshot-archiving/types`);
const useSnapshotArchivingTypes = () => useQuery({
  queryKey: ["snapshotArchivingTypes"],
  queryFn: () => defaultOnError(
    fetch("GET", url),
    "Loading snapshot archiving types failed with status",
    "Could not load snapshot archiving types."
  ),
  staleTime: 6e4
});
export default useSnapshotArchivingTypes;
